import { useToast as useNuxtToast, type Toast } from '@nuxt/ui/composables/useToast'
import { addKontyToast } from 'app-theme'

/**
 * The admin's one way to show a toast — every screen and the kit's `kontyToast` seam add
 * through it (a spec keeps Nuxt UI's own `useToast` out of everywhere else). It applies the
 * shared Konty toast rules (`addKontyToast`): one toast at a time, the text centred, an
 * icon on a success, warning or error, 2.5 s for a confirmation and 6 s for a warning or error
 * unless the caller sets a duration.
 */
export function useToast() {
    const nuxtToast = useNuxtToast()

    return {
        add: (toast: Partial<Toast>): Toast => addKontyToast(nuxtToast, toast)
    }
}
